import { TrendingUp } from 'lucide-react';

const Bar = ({ label, value, max, color }) => {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  return (
    <div className="space-y-1.5">
      <div className="flex justify-between">
        <span className="text-xs" style={{ color: "var(--lm-ink-2)" }}>{label}</span>
        <span className="text-xs font-medium" style={{ color }}>{value}</span>
      </div>
      <div className="h-1 rounded-full overflow-hidden" style={{ backgroundColor: "var(--lm-border)" }}>
        <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
    </div>
  );
};

const DashboardActivityCard = ({ t, stats }) => {
  const total = stats.totalEmployees || 1;
  const present = stats.presentToday ?? 0;
  const absent = stats.absentToday ?? 0;
  const late = stats.lateArrivals ?? 0;
  const pending = stats.pendingApprovals ?? 0;
  const onTime = Math.max(0, present - late);

  return (
    <div className="col-span-3 rounded-xl overflow-hidden" style={{ backgroundColor: "var(--lm-s1)", border: "1px solid var(--lm-border)" }}>
      <div className="flex items-center justify-between px-5 py-4" style={{ borderBottom: "1px solid var(--lm-border)" }}>
        <div>
          <h3 className="text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>{t('dashboard.todayOverview')}</h3>
          <p className="text-xs mt-0.5" style={{ color: "var(--lm-ink-2)" }}>{t('dashboard.today')}</p>
        </div>
        <TrendingUp className="w-4 h-4" style={{ color: "#5e6ad2" }} />
      </div>

      <div className="p-5 space-y-4">
        <Bar label={t('dashboard.onTime')}         value={onTime}  max={total} color="var(--lm-success)" />
        <Bar label={t('attendance.checkIn')}        value={present} max={total} color="#5e6ad2" />
        <Bar label={t('dashboard.lateArrivals')}    value={late}    max={total} color="var(--lm-warn)" />
        <Bar label={t('dashboard.absentToday')}     value={absent}  max={total} color="var(--lm-error, #e5484d)" />

        <div className="pt-2" style={{ borderTop: "1px solid var(--lm-border)" }}>
          <div className="flex items-center justify-between px-3 py-2 rounded-lg"
            style={{ backgroundColor: "rgba(94,106,210,0.08)", border: "1px solid rgba(94,106,210,0.2)" }}>
            <span className="text-xs font-semibold" style={{ color: "#828fff" }}>{t('dashboard.pendingApprovals')}</span>
            <span className="text-sm font-semibold" style={{ color: "#828fff" }}>{pending}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardActivityCard;
